import AlarmCentrals              from 'scripts/defa/alarm-centrals/collection-alarm-centrals';
import AlarmCentral               from 'scripts/defa/alarm-centrals/model-alarm-central';
import AlarmCentralCollectionView from 'scripts/defa/alarm-centrals/view-alarm-central-collection-view';
import AlarmCentralContainer      from 'scripts/defa/alarm-centrals/view-alarm-central-container';
import Module                     from 'scripts/module';

const AlarmCentralsModule = new Module( 'AlarmCentralsModule', {
	collections: {
		AlarmCentrals
	},
	models     : {
		AlarmCentral
	},
	views      : {
		AlarmCentralCollectionView,
		AlarmCentralContainer
	}
} );

export default AlarmCentralsModule;